import { classNames } from '@wix/answers-lib';
export var namespaceClassName = 'aul';
export var namespacedClassnames = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return classNames(namespaceClassName, args);
};
//# sourceMappingURL=namespace-classes.js.map